<template>
  <webinar-page v-if="loginStatus === 'auth' || archived" :archived="archived"
                :webinar="webinar"/>
  <div class="webinar__loading" v-else>
    <div class="webinar__loading"
         v-if="loginStatus === 'loading' || loading">
      <Loading/>
    </div>
    <div class="login-form" v-else>
      <form @submit.prevent="loginForm">
        <h2>{{ t('public.loginTitle') }}</h2>
        <p>{{ t('public.authOnly') }}</p>
        <input name="name" :placeholder="t('public.name')" v-model="form.name"
               required/>
        <input name="email" type="email" :placeholder="t('public.email')"
               required
               v-model="form.email"/>
        <button>{{ t('public.loginButton') }}</button>
      </form>
    </div>
  </div>
</template>

<script lang="ts">
import { computed, defineComponent, ref } from 'vue'
import axios from 'axios'
import Loading from '@/vue/public/Loading.vue'
import WebinarPage from '@/vue/public/WebinarPage.vue'
import { Webinar as WebinarData } from '@/types/webinar.d'
import { useStore } from 'vuex'
import { key } from '@/vue/store'
import { useI18n } from 'vue-i18n'
import { key as i18nKey } from '@/vue/i18n'

declare global {
  interface Window {
    webinarData: WebinarData
  }
}

export default defineComponent({
  components: {
    WebinarPage,
    Loading,
  },
  setup() {
    const { t } = useI18n()
    const i18n = useStore(i18nKey)
    i18n.dispatch('init')

    const store = useStore(key)
    store.dispatch('checkAuth')

    const loginStatus = computed(() => store.state.status)

    const loading = ref(false)

    const form = ref({
      email: '',
      name: '',
    })

    const webinar = window.webinarData

    const loginForm = async () => {
      loading.value = true
      await axios.post('/login_client', {
        ...form.value,
        webinar: webinar?.id,
        utm: document.location.search,
      })
      await store.dispatch('checkAuth')
      loading.value = false
    }

    const archived = /[&|?]archived=1/.test(document.location.search)

    return {
      loginStatus,
      loading,
      loginForm,
      form,
      webinar,
      t,
      archived,
    }
  },
})
</script>

<style lang="stylus">
body
  background var(--light-bg-color)

.webinar__loading
  background var(--dark-bg-color)
  fixed top left
  size 100%
  display flex
  align-items center
  justify-content center
  color #fff
  font-weight bold
  font-size 3rem

.login-form
  width 340px
  max-width 100%

  form
    background #fff
    padding 30px 20px
    box-shadow 0 3px 15px 3px rgba(27, 38, 56, .1)
    border-radius 5px
    color var(--text-color)
    font-weight normal

    h2
      font-size 14px
      line-height 16px
      margin-bottom 20px
      font-weight bold

    p
      color var(--grey-text-color)
      font-size 12px
      line-height 14px
      margin-bottom 10px

    input
      display block
      border-radius 3px
      background var(--input-bg-color)
      height 38px
      margin-bottom 20px
      border 1px solid transparent
      width 100%
      padding 0 10px
      outline 0

      &:focus
        border-color var(--input-border-color)

    button
      background var(--button-color)
      height 42px
      display flex
      align-items center
      justify-content center
      text-transform uppercase
      border-radius 3px
      color var(--button-text-color)
      width 100%
      font-weight bold
      border 0
      cursor pointer
      outline 0
</style>
